<lib-infinite-scroll class="user-accounts__wrapper" (scrolled)="onScrolled()">

  @if (accountsSummary$ | async; as accountsSummary) {
    <rrp-user-account-item
      class="user-accounts__item"
      [class.user-accounts__item--active]="(isCurrentAccountEmpty() | async) ?? true"
      [isActive]="(isCurrentAccountEmpty() | async) ?? true"
      [title]="'user-accounts.all-accounts' | translate"
      [account]="accountsSummary"
      (click)="onUserAccountClick(null)"
    />
  } @else {
    <rrp-user-account-item-skeleton/>
  }

  <lib-option-list
    [loading]="!!(loading$ | async)"
    [options]="(accounts$ | async) ?? []"
    [itemTemplate]="accountTemplate"
    [loaderTemplate]="loaderTemplate"
  ></lib-option-list>
</lib-infinite-scroll>

<ng-template #accountTemplate let-option>
  <rrp-user-account-item
    class="user-accounts__item"
    [class.user-accounts__item--active]="(isAccountActive(option.id) | async) ?? false"
    [isActive]="(isAccountActive(option.id) | async) ?? false"
    [account]="asAccount(option)"
    (click)="onUserAccountClick(option)"
  ></rrp-user-account-item>
</ng-template>

<ng-template #loaderTemplate>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
  <rrp-user-account-item-skeleton/>
</ng-template>
